import container from '@/plugins/services';
import i18n from '@/plugins/i18n'
import '@/plugins/env';
import { OrugaConfig } from '@/plugins/oruga';
import Vue from 'vue';

export default Vue.extend({
    i18n,
    provide: {
        ...container.getAll()
    },
    created() {
        this.$oruga.config.setOptions(OrugaConfig);
    }
})